module.exports = __webpack_public_path__ + "img/icon-sb-mattress-firm-color-36.a47e8a9.svg";